import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ComponentPropsWithoutRef } from "react";

export interface BodyProps extends ComponentPropsWithoutRef<"div"> {
  hasPaddingTopMobile?: boolean;
  isMinimalLayout?: boolean;
  wrapperClassName?: string;
}

export const PageBody = ({
  hasPaddingTopMobile = true,
  isMinimalLayout,
  children,
  className,
  wrapperClassName,
  ...rest
}: BodyProps) => (
  <div
    className={classNames(
      "min-h-full [container-type:inline-size]",
      "max-lg:flex max-lg:grow",
      !isMinimalLayout && "lg:bg-secondary",
      className,
    )}
    {...rest}
  >
    <div
      className={classNames(
        "min-h-full pt-3 sm:mx-6 lg:mx-9 lg:pt-6 max-lg:!mx-0 max-lg:min-w-0 max-lg:grow max-lg:pt-0",
        {
          "pt-0": !hasPaddingTopMobile,
          "px-4 sm:px-0": isMinimalLayout,
        },
        wrapperClassName,
      )}
    >
      {children}
    </div>
  </div>
);

export const Body = PageBody;
